import React from 'react';
import { useLocation } from 'react-router-dom';
import { Form, Button, Card } from 'react-bootstrap';
import fisio from '../../../assets/esp-fisio.jpg';
import styles from '../../../styles.module.css';
import LaudoCardHeader from '../../../components/laudos/LaudoCardHeader';
import EspelhoStressHeader from './EspelhoStressHeader';

export default function EspelhoFisio() {
  const location = useLocation();
  const stress = location.state && location.state.stress;

  return (
    <>
      <style>
        {`
        @page {
      size: A4;
      margin: 10mm;
    }

    @media print {
      html,
      body {
        background: #fff !important;
        margin: 0;
        padding: 0;

        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
      }

      #printMe {
        background: #fff !important;
      }

      .print-container {
        background: #fff !important;
      }

      .print-image {
        width: 80%;
        height: auto;
        break-inside: avoid;
      }

      #removeMe {
        display: none !important;
      }

      .page {
        page-break-after: always;
      }

      .page:last-of-type {
        page-break-after: auto;
      }
    }
  `}
      </style>
      <Card id="cardHeader">
        <div id="printMe">
          <LaudoCardHeader title="LAUDO DE ECO ESTRESSE - FISIO" />

          <Card.Body>
            <Form noValidate className={styles.contentReport}>
              <EspelhoStressHeader stress={stress} />
              <div className="print-container">
                <img
                  src={fisio}
                  alt="espelho fisio"
                  loading="eager"
                  className="print-image"
                />
              </div>
            </Form>
          </Card.Body>
        </div>
        <div id="removeMe" className="text-right">
          <Button onClick={() => window.print()}>Imprimir</Button>
        </div>
      </Card>
    </>
  );
}
